import { toOwnershipPayload } from './collectionAcquisition.js'
import { buildWearLogEntry, todayISO } from './wearLogContext.js'

// Keep the persisted bottle after a wear failure, so retry never buys another
// collection row. This state belongs to the mounted Home flow, not global auth.
export function createCatalogSotdState() {
  return { pending: null, bottles: new Map(), saved: new Map() }
}

export function saveCatalogSotd(state, { item, owned, addFragrance, addLog, now = new Date() }) {
  if (state.pending) return state.pending
  const key = `${todayISO(now)}:${item.catalog_id || item.id}`
  if (state.saved.has(key)) return Promise.resolve(state.saved.get(key))
  state.pending = (async () => {
    addLog.assertReady?.() // Refuse before acquiring any additional bottle while an earlier wear is uncertain.
    let bottle = owned || state.bottles.get(key)
    if (!bottle) {
      bottle = await addFragrance(toOwnershipPayload(item))
      state.bottles.set(key, bottle)
    }
    const log = await addLog({
      ...buildWearLogEntry(bottle, { date: todayISO(now) }),
      wear_label: 'sotd',
    }, { applied_at: now.toISOString(), sprays: null })
    const result = { bottle, log }
    state.saved.set(key, result)
    return result
  })().finally(() => { state.pending = null })
  return state.pending
}
